var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn-icon",attrs:{"disabled":_vm.isDisabled,"title":_vm.tooltip}},_vm.$listeners),[_vm._t("default",[_c('IconMaterial',{attrs:{"title":_vm.iconMaterial,"size":_vm.size}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }